import React from 'react'
import Icon from './Icon'

const ArrowDropDown = props => (
    <Icon viewBox="0 0 40 40" {...props}>
        <g><path d="m10 15h20l-10 10z"/></g>
    </Icon>
)

export default ArrowDropDown



// WEBPACK FOOTER //
// ./icons/ArrowDropDown.js